import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function StatesboroProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Statesboro"
      headingExtra="Georgia"
      introText="Statesboro travelers — Georgia Southern University students studying abroad, Bulloch County families planning international vacations, and southeast Georgia agricultural business owners — have several options for getting a passport fast. Here is how they compare, and why most southeast Georgia residents choose a registered U.S. Department of State passport courier for predictable, professional processing."
      options={options}
      emergencyDescription="Atlanta ~210 mi via I-16/I-75 (3.5+ hrs). Georgia has only ONE passport agency (Atlanta) serving 11M+ statewide residents. Georgia Southern University sends hundreds of students abroad every semester — a student discovering an expired passport 48 hours before departure faces a 7+ hour round trip on I-16, which has extremely limited services between Statesboro and Macon. I-16 through rural southeast Georgia has no alternate route — a single accident or summer thunderstorm adds hours with zero detour. Hurricane evacuation from the Georgia coast clogs I-16 heading inland, making Atlanta unreachable."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Georgia has only one passport agency (Atlanta) serving 11M+ statewide residents."
    />
  );
}